// extracted by mini-css-extract-plugin
export var gutters = "Gutters-module--gutters--28yzd";
export var fadeOutAnimation = "Gutters-module--fadeOutAnimation--L_5u1";
export var fadeInAnimation = "Gutters-module--fadeInAnimation--3HUbX";